import { c as E, C as p, L as q, h as m, r as H, R, o as x, N as T } from "./version-CLBYgaXw.js";
import { g as J, v as K } from "./version-CLBYgaXw.js";
const C = async function(n, o, e) {
  const t = await E(n, o, e), r = new URL(t.url), i = t.params;
  i instanceof Object && Object.keys(i).forEach((a) => r.searchParams.set(a, i[a]));
  const s = new AbortController();
  function c() {
    s.signal.aborted || s.abort();
  }
  t.abort && t.abort.addEventListener("abort", c);
  const f = t.timeout > 0 ? setTimeout(c, t.timeout) : null, b = new Request(r, {
    method: t.method,
    headers: new Headers(t.headers),
    body: t.body,
    credentials: t.credentials,
    signal: s.signal,
    redirect: "follow"
  });
  return await fetch(b).then(async (a) => ({
    url: r.toString(),
    method: t.method,
    status: a.status,
    statusText: a.statusText,
    headers: Object.fromEntries(a.headers.entries()),
    body: t.method === "HEAD" ? "" : await a.text()
  })).catch((a) => ({
    url: r.toString(),
    method: t.method,
    status: -1,
    statusText: s.signal.aborted ? "Aborted" : "NetworkError",
    body: String(a)
  })).finally(() => {
    f !== null && clearTimeout(f), t.abort && t.abort.removeEventListener("abort", c);
  });
}, y = async function(n, o, e) {
  const t = {
    ...await E(n, o, e),
    onUploadProgress: e == null ? void 0 : e.onUploadProgress
  }, r = t.method, i = t.onUploadProgress || q, s = p(t.url, t.params);
  return await new Promise((c) => {
    let f = 1;
    function b(w) {
      f = w.total, i({ total: w.total, loaded: w.loaded });
    }
    let a = null, u = !1;
    const h = function() {
      u || (l.abort(), u = !0);
    };
    function g() {
      a !== null && clearTimeout(a), t.abort && t.abort.removeEventListener("abort", h);
    }
    const l = new XMLHttpRequest();
    l.open(r, s, !0), l.upload.addEventListener("progress", b), l.addEventListener("load", () => {
      g(), i({ loaded: f, total: f }), c({
        url: s,
        method: r,
        status: l.status,
        statusText: l.statusText,
        headers: U(l),
        body: r === "HEAD" ? "" : l.responseText
      });
    }), l.addEventListener("error", () => {
      g(), c({
        url: s,
        method: r,
        status: -1,
        statusText: "Failed",
        body: ""
      });
    }), l.addEventListener("abort", () => {
      g(), c({
        url: s,
        method: r,
        status: -1,
        statusText: "Aborted",
        body: ""
      });
    }), Object.entries(t.headers).forEach(([w, L]) => {
      l.setRequestHeader(w, L);
    }), t.credentials === "include" && (l.withCredentials = !0), l.send(t.body || void 0), t.abort && t.abort.addEventListener("abort", h), t.timeout > 0 && (a = setTimeout(h, t.timeout));
  });
};
function U(n) {
  const o = {};
  if (!n)
    return o;
  const e = n.getAllResponseHeaders();
  return e && e !== "null" && e.replace(/\r/g, "").split(`
`).forEach((t) => {
    const r = t.trim();
    if (!r)
      return;
    const i = r.split(":"), s = i[0].trim();
    s && (o[s] = (i[1] || "").trim());
  }), o;
}
const v = async function(n, o, e) {
  return m(await H(C, n, o, e), n, o, e);
}, S = async function(n, o, e) {
  return m(await H(y, n, o, e), n, o, e);
};
async function j(n, o, e, t) {
  const r = e == null ? void 0 : e.body, i = (e == null ? void 0 : e.method) === "PUT" ? "PUT" : "POST";
  if (o instanceof Blob) {
    const a = new R(t), u = await y(n, a, {
      ...e,
      method: i,
      body: o
    });
    return m(u, n, a, e);
  }
  const s = new FormData(), c = { ...o };
  r instanceof Object && Object.entries(r).forEach(([a, u]) => {
    u instanceof Blob ? c[a] = u : Array.isArray(u) ? u.forEach((h, g) => {
      s.append(`${a}[${g}]`, String(h));
    }) : s.append(a, String(u));
  });
  for (const a in c)
    s.append(a, c[a]);
  const f = new R(t), b = await y(n, f, {
    ...e,
    method: i,
    body: s
  });
  return m(b, n, f, e);
}
async function k(n, o, e = {}) {
  const t = window;
  "callback" in e || (e.callback = "jsonxData" + Math.random().toString(16).slice(2));
  const r = e.callback + "";
  if (!n)
    return null;
  const i = p(n, e, !0);
  return new Promise((s) => {
    t[r] = function(c) {
      if (r in window && delete t[r], o(c))
        return c;
      console.warn("response type check faild", n, c), s(null);
    }, x(i).catch(function() {
      s(null), delete t[r];
    });
  });
}
async function A(n, o, e = {}) {
  const t = window;
  return "var" in e || (e.var = "jsonxData" + Math.random().toString(16).slice(2)), n ? await x(p(n, e, !0)).then(() => {
    const r = t[e.var + ""];
    return o(r) ? r : (console.warn("response type check faild", n, r), null);
  }).catch(() => null) : null;
}
const D = async function(n, o, e) {
  return await j(n, o, e, {
    baseURL: d.getConfig("baseURL"),
    logHandler: d.getConfig("logHandler"),
    errorHandler: d.getConfig("errorHandler"),
    requestTransformer: d.getConfig("requestTransformer"),
    messageHandler: d.getConfig("messageHandler"),
    responseHandler: d.getConfig("responseHandler")
  });
};
function O(n) {
  if ("window" in globalThis)
    return "fetch" in window ? new T(v, n) : new T(S, n);
  throw new Error("Default Module Only Support In Browser");
}
const d = O(), M = d.setConfig, N = d.head, F = d.get, B = d.post, X = d.del, G = d.put, I = d.patch;
export {
  O as NetRequest,
  X as del,
  F as get,
  J as getResponseRulesDescription,
  N as head,
  k as jsonp,
  A as jsonx,
  I as patch,
  B as post,
  G as put,
  M as setGlobalConfig,
  D as upload,
  K as version
};
